module.exports = __webpack_public_path__ + "img/algebra-logo-full-color-crop.8aaa7b09.png";